import career_intern_en from "./intern-en.json";
import career_intern_tc from "./intern-tc.json";

export type CareerInternData = {
  company: string;
  jobTitle: string;
  major: string;
  year: string;
  detail: string; // under https://www.hkctc.gov.hk
};

/**
 * Converts raw company and internship job data into CareerInternData[] format.
 * For each company entry, only the first job in the array retains the `company` and `detail` fields.
 * All other jobs will have an empty string for `company` and `detail`.
 *
 * @param data - Array of company data with nested job arrays
 * @returns A flat array of CareerInternData objects
 */

const processCareerInternJson = (jsonData: any[]): CareerInternData[] => {
  return jsonData?.flatMap(({ company, detail, job }) =>
    job.map((j: any, index: number) => ({
      company: !index ? company : "", // Only the first job keeps the company name
      jobTitle: j?.title,
      major: j?.major,
      year: j?.year,
      detail: !index ? detail : "", // Only the first job keeps the detail link
    }))
  );
};

export const careerIntern_en_rows: CareerInternData[] =
  processCareerInternJson(career_intern_en);

export const careerIntern_tc_rows: CareerInternData[] =
  processCareerInternJson(career_intern_tc);
